import React from 'react';
import Button from '../../ui/Button';
import { ChevronRight, CheckCircle2 } from 'lucide-react';

const MarketerHero: React.FC = () => {
  return (
    <div className="relative pt-20 pb-16 sm:pt-32 sm:pb-24 lg:pb-32 overflow-hidden bg-slate-950">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-sky-900/20 via-slate-950/0 to-slate-950 pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-sky-500/30 bg-sky-500/10 text-sky-400 text-xs font-bold mb-8 uppercase tracking-wide">
            <span className="flex h-2 w-2 rounded-full bg-sky-500 mr-2 animate-pulse"></span>
            Verified Data for Professional Services Marketers
          </div>

          <h1 className="text-5xl tracking-tight font-extrabold text-white sm:text-6xl md:text-7xl mb-8 leading-tight">
            Verified Data for People Who Market to <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-indigo-400">Licensed Professionals</span>
          </h1>
          
          <p className="mt-4 max-w-2xl mx-auto text-lg sm:text-xl text-slate-400 leading-relaxed">
            Real estate coaches, insurance recruiters, and agency owners use ProGeoData to find active, licensed professionals with accurate contact info — <span className="text-slate-200 font-medium">not 6-month-old zombie data.</span>
          </p>

          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4 items-center">
            <Button size="lg" className="w-full sm:w-auto" onClick={() => document.getElementById('pricing')?.scrollIntoView({behavior: 'smooth'})}>
              Start Free Trial <ChevronRight className="ml-2 w-4 h-4" />
            </Button>
            <Button variant="ghost" size="lg" className="w-full sm:w-auto text-slate-300 hover:bg-slate-900" onClick={() => document.getElementById('pricing')?.scrollIntoView({behavior: 'smooth'})}>
              See Pricing
            </Button>
          </div>

          <div className="mt-12 flex flex-wrap justify-center gap-6 text-sm text-slate-500 font-medium">
            <div className="flex items-center"><CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" /> Regular License Verification</div>
            <div className="flex items-center"><CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" /> Direct Contact Info</div>
            <div className="flex items-center"><CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" /> No Contracts</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketerHero;